import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './TextActionButton.module.css';

export const TextActionButton = forwardRef(function TextActionButton(
  { children, className = '', type = 'button', ...rest },
  ref,
) {
  return (
    <button ref={ref} type={type} className={clsx(styles.root, className)} {...rest}>
      {children}
    </button>
  );
});
